<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t($route.name) }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @getAllRows="getAllRows"
          >
          <export-excel
            ref="refExcel"
            :data="excelItems"
            worksheet="abriron.com"
            name="data.xls"
            type="xls"
            class="float-left d-flex"
            :title="$store.state.abrName"
            :total-prop="pageCount"
            :page-prop="excelPage"
            @getAllRows="getAllRows"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('excel')" />
          </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="goTo(type)"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(type)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        style="min-width: 35px !important;padding: 0 !important;"
        @shortkey="getItems"
        v-shortkey="['f5']"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn
          outlined
          class="mt-4 ms-2"
          color="grey darken-2 "
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t('excel') }}
          </p>
          <v-icon>
            mdi-file-excel-outline
          </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('filter') }}
        </p>
        <v-icon>
          mdi-filter-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="mb-4 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-6': !isMobile && !isTablet , 'mt-0': isMobile || isTablet}"
    >
      <v-data-table
        v-if="headers"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        v-model="selected"
        :headers="headers"
        :items="items"
        :page.sync="page"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + (typeForm == 'product' ? 'product':'service') +'/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item
                v-show="removePermission('details')"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status === 'active'"
            small
            color="blue"
            outlined
          >
            {{ $t('active') }}
          </v-chip>
          <v-chip
            v-if="item.lead === 'active'"
            small
            color="orange"
            class="mx-1"
            outlined
          >
            {{ $t('lead') }}
          </v-chip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.system.name="{ item }">
          {{ item.system ? item.system.name : 'ندارد' }}
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="pt-1" v-if="item.tags">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
          <v-card-text class="pa-0 text-caption text-disable">ندارد</v-card-text>
        </template>
        <template v-slot:item.content="{ item }">
          {{ item.content ? item.content : 'ندارد' }}
        </template>
        <template v-slot:item.remain="{ item }">
          {{ (item.remain ? $numberFormat(item.remain.remain) : 0) }}
          {{(item.remain && $store.state.currency.id !== item.remain.currency.id ? '(' + item.remain.currency_remain + '  ' + item.remain.currency.symbol + ')': '')}}
        </template>
        <template v-slot:item.currency="{ item }">
          {{item.currency.name}}
        </template>
        <template v-slot:item.code="{ item }">
          {{item.group.code}}{{item.code}}
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template
          v-slot:body.append
        >
          <tr :class="{'v-data-table__mobile-table-row':isMobile}">
            <td
              :colspan="`${isMobile?6:6}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('sum') +':': '') }}  {{ $numberFormat(totals.sum) }}
            </td>
            <td
              :colspan="`${isMobile?6:5}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  export default {
    name: 'detailList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      Print,
      Task,
    },
    mixins: [General],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      selected: [],
      excelItems: [],
      printDialog: false,
      deletDialog: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      pageCount: 1,
      page: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
    }),
    computed: {
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      totals: function () {
        const totals = this.items.reduce((acc, d) => {
          acc.sum += (d.remain ? parseFloat(d.remain.remain) : 0)
          acc.discount += parseFloat(0)
          acc.tax += parseFloat(0)
          return acc
        }, {
          sum: 0,
          discount: 0,
          tax: 0,
        })
        return totals
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.page = 1
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    beforeMount () {
      if (this.$route.name === 'bankList') {
        this.type = 'bank'
      }
      if (this.$route.name === 'cashList') {
        this.type = 'cash'
      }
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'financial_detail_coding.id',
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'name',
          table: 'financial_detail_coding.name',
        },
        {
          text: this.$t('accountCode'),
          sortable: false,
          value: 'code',
          table: 'financial_detail_coding.code',
        },
        {
          text: this.$t('group'),
          sortable: false,
          value: 'group.name',
        },
        {
          text: this.$t('systemLink'),
          sortable: false,
          value: 'system.name',
        },
        {
          text: this.$t('tag'),
          sortable: false,
          value: 'tags',
        },
        {
          text: this.$t('content'),
          sortable: false,
          value: 'content',
          table: 'bank_cash.content',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
        },
      ]
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      }
      this.typeForm = 'detail'
      this.selectedHeaders = this.headers
    },
    activated () {
      this.getItems()
    },
    mounted () {
      if (this.input) {
        this.model = this.input
      }
      // this.getItems()
    },
    methods: {
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'detailEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'detail', {
          params: {
            search: app.search,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'detail/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'detail/0', {
          params: { deleteItems: app.selected },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            id: d.id,
            name: d.name,
            code: d.code,
            group: (d.group ? d.group.name : ''),
          })
        })
      },
    },
  }
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
